// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 53 ? "e2279502" : chunkId) + "." + {"53":"b037cb5e9ebc0b48","116":"3459f41074bbfcac","789":"c2b089e543a75a10"}[chunkId] + ".js";
};